import { env } from "@env";

export const appEnv = {
    CONFIGURADOR_BASEURL: import.meta.env.VITE_CONFIGURATOR_BASEURL ?? env.REACT_APP_CONFIGURATOR_BASEURL,
    DATABRIDGE_BASEURL: import.meta.env.VITE_DATABRIDGE_BASEURL ?? env.REACT_APP_DATABRIDGE_BASEURL,
    COOKIE_NAME: import.meta.env.VITE_COOKIE_NAME ?? env.REACT_APP_COOKIE_NAME,
    COOKIE_DOMAIN: import.meta.env.VITE_COOKIE_DOMAIN ?? env.REACT_APP_COOKIE_DOMAIN,
    JWT_NAME: import.meta.env.VITE_JWT_NAME ?? env.REACT_APP_JWT_NAME,
};